import { render, staticRenderFns } from "./putmain.vue?vue&type=template&id=47fe83cc&scoped=true"
import script from "./putmain.vue?vue&type=script&lang=js"
export * from "./putmain.vue?vue&type=script&lang=js"
import style0 from "./putmain.vue?vue&type=style&index=0&id=47fe83cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe83cc",
  null
  
)

export default component.exports